import { Column } from "@/components";

export const PlayyardLightSnow = () => {
  /* Render */
  const render = () => (
    <Column className="pointer-events-none absolute inset-0 z-40 overflow-hidden">
      <Column
        className="staffer-pet-yard-snow absolute inset-0 opacity-50"
        style={{
          backgroundSize: "130px 145px, 100px 120px",
          animationDuration: "21s",
        }}
      />
      <Column
        className="staffer-pet-yard-snow absolute inset-0 opacity-40"
        style={{
          backgroundSize: "210px 230px, 170px 195px",
          animationDuration: "15s",
          animationDelay: "-8s",
        }}
      />
    </Column>
  );

  return render();
};
